export default __webpack_public_path__ + "static/media/img-0389-serbia-full-face.0c859025.png";